const ADMIN_HOSTNAME = 'admin.advictinternational.com'
const PUBLIC_SITE_URL = 'https://advictinternational.com'

export function isAdminSubdomain() {
  return typeof window !== 'undefined' && window.location.hostname.toLowerCase() === ADMIN_HOSTNAME
}

export function adminUrl(path = '') {
  const suffix = path ? `/${path.replace(/^\/+/, '')}` : ''
  return isAdminSubdomain() ? suffix || '/' : `/admin${suffix}`
}

export function publicSiteUrl(path = '/') {
  return `${PUBLIC_SITE_URL}${path}`
}
